import styled, { css } from 'styled-components';
import { BodySmBold, BodyXsBold } from '@seed-health/tokens';
import { mqMediumMin, mqLargeMin } from 'styled/tools/media-queries';
import type { BadgeColor, BadgeSize } from '.';

const getBgColor = (color: BadgeColor): string => {
  const colorMap: Record<BadgeColor, string> = {
    brand: 'var(--fill-brand)',
    'brand-inverse': 'var(--fill-primary)',
    am: 'var(--products-am-02-dark)',
    dm: 'var(--products-dm-02-dark)',
    pm: 'var(--products-pm-02-dark)',
    dvs: 'var(--products-dvs-01-dark)',
    'guidance-primary': 'var(--guidance-primary)',
  };
  return colorMap[color];
};

const getTextColor = (color: BadgeColor): string => {
  if (color === 'guidance-primary' || color === 'brand-inverse')
    return 'var(--text-primary)';
  return 'var(--text-inverse-primary)';
};

const sharedStyles = `
gap: var(--spacing-4);
svg {
  width: 12px;
  height: 12px;
  fill: currentColor;
}`;

const sizeStyles: Record<BadgeSize, ReturnType<typeof css>> = {
  // NOTE: x-axis padding increments by 1px; y-axis by 2px
  sm: css`
    ${BodyXsBold}
    padding: 1px var(--spacing-8);
    ${sharedStyles}
  `,
  md: css`
    ${BodySmBold}
    padding: 2px 10px;
    ${sharedStyles}
  `,
  lg: css`
    ${BodySmBold}
    padding: 3px 12px;
    gap: var(--spacing-8);
    svg {
      width: 14px;
      height: 14px;
      fill: currentColor;
    }
  `,
};

export const BadgeWrapper = styled.span<{
  $color: BadgeColor;
  $sizeBase: BadgeSize;
  $sizeTablet?: BadgeSize;
  $sizeDesktop?: BadgeSize;
}>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  max-width: 100%;
  border-radius: var(--radius-full);
  background-color: ${({ $color }) => getBgColor($color)};
  color: ${({ $color }) => getTextColor($color)};

  ${({ $sizeBase }) => sizeStyles[$sizeBase]}

  ${({ $sizeTablet }) =>
    $sizeTablet &&
    css`
      @media ${mqMediumMin} {
        ${sizeStyles[$sizeTablet]}
      }
    `}

  ${({ $sizeDesktop }) =>
    $sizeDesktop &&
    css`
      @media ${mqLargeMin} {
        ${sizeStyles[$sizeDesktop]}
      }
    `}
`;
